<script setup>
import { computed } from 'vue'
import { useUserStore } from '../../stores/userStore'

const userStore = useUserStore()
const isAdmin = computed(() => userStore.currentUser?.role === 'admin')

const props = defineProps({
  ou1Balanced: {
    type: Object,
    default: null
  },
  ou2Balanced: {
    type: Object,
    default: null
  },
  event: {
    type: Object,
    default: null
  }
})

const emit = defineEmits(['open-modal'])

const handleClick = () => {
  emit('open-modal')
}
</script>

<template>
  <div v-if="isAdmin" class="flex items-center justify-center h-full">
    <!-- Single Combined Box -->
    <div 
      @click="handleClick"
      class="bg-white rounded-lg shadow-sm border border-gray-200 p-3 cursor-pointer hover:shadow-md hover:border-blue-300 transition-all flex items-center gap-4 h-full min-w-[600px]"
    >
      <!-- OU1 Section -->
      <div class="flex-1 flex flex-col items-center justify-center">
        <div class="text-[10px] font-semibold text-gray-500 uppercase mb-1 text-center">
          {{ event?.ocHomeTeamName || event?.home || 'Home' }} - OU1
        </div>
        <div v-if="ou1Balanced" class="text-center">
          <div class="text-lg font-bold text-gray-900 mb-0.5">
            {{ ou1Balanced.line }}
          </div>
          <div class="flex items-center justify-center gap-2 text-xs">
            <div class="flex flex-col items-center">
              <span class="text-gray-400 text-[10px]">Over</span>
              <span class="font-semibold text-green-600">{{ ou1Balanced.over }}</span>
            </div>
            <span class="text-gray-300">/</span>
            <div class="flex flex-col items-center">
              <span class="text-gray-400 text-[10px]">Under</span>
              <span class="font-semibold text-red-600">{{ ou1Balanced.under }}</span>
            </div>
          </div>
          <div class="text-[10px] text-gray-400 mt-0.5">
            Diff: {{ ou1Balanced.diff.toFixed(3) }}
          </div>
        </div>
        <div v-else class="text-gray-400 text-xs">
          No data
        </div>
      </div>

      <!-- Divider -->
      <div class="w-px h-12 bg-gray-200"></div>

      <!-- OU2 Section -->
      <div class="flex-1 flex flex-col items-center justify-center">
        <div class="text-[10px] font-semibold text-gray-500 uppercase mb-1 text-center">
          {{ event?.ocAwayTeamName || event?.away || 'Away' }} - OU2
        </div>
        <div v-if="ou2Balanced" class="text-center">
          <div class="text-lg font-bold text-gray-900 mb-0.5">
            {{ ou2Balanced.line }}
          </div>
          <div class="flex items-center justify-center gap-2 text-xs">
            <div class="flex flex-col items-center">
              <span class="text-gray-400 text-[10px]">Over</span>
              <span class="font-semibold text-green-600">{{ ou2Balanced.over }}</span>
            </div>
            <span class="text-gray-300">/</span>
            <div class="flex flex-col items-center">
              <span class="text-gray-400 text-[10px]">Under</span>
              <span class="font-semibold text-red-600">{{ ou2Balanced.under }}</span>
            </div>
          </div>
          <div class="text-[10px] text-gray-400 mt-0.5">
            Diff: {{ ou2Balanced.diff.toFixed(3) }}
          </div>
        </div>
        <div v-else class="text-gray-400 text-xs">
          No data
        </div>
      </div>

      <!-- Chevron Icon -->
      <i class="fas fa-chevron-right text-gray-400 text-sm"></i>
    </div>
  </div>
</template>

<style scoped>
/* Component styles */
</style>
